import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'acessories',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `acessories`,
    method: 'get',
    params: queriesParams
  })
}

export function addAcessory (acessory) {
  return request({
    method: 'post',
    url: 'acessories',
    data: acessory
  })
}

export function show (id) {
  return request({
    url: `acessories/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `acessories/${id}`,
    method: 'patch',
    data
  })
}
